import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=353af8da"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports